import React from 'react';
import IconButton from '../ui/IconButton';
import { useOverlays } from '../overlays/OverlayProvider';
import './shell.css';

const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || '');

/** 60px top bar: palette trigger styled as an input, environment chip, bell, help. */
export default function TopBar({ environment = 'Production', hasNotifications = true }) {
  const { openPalette } = useOverlays();

  return (
    <header className="sv-topbar">
      <button type="button" className="sv-search-trigger" onClick={openPalette}>
        <i className="bx bx-search" aria-hidden="true" />
        <span className="sv-search-trigger__text">Search partners, sessions, coupons…</span>
        <span className="sv-search-trigger__kbd sv-mono">{IS_MAC ? '⌘K' : 'Ctrl K'}</span>
      </button>

      <div className="sv-topbar__right">
        <span className="sv-env-chip">{environment}</span>
        <IconButton icon="bx-bell" label="Notifications" dot={hasNotifications} />
        <IconButton icon="bx-help-circle" label="Help" />
      </div>
    </header>
  );
}
